import { render, staticRenderFns } from "./Forwarder.vue?vue&type=template&id=05df558f&scoped=true"
import script from "./Forwarder.vue?vue&type=script&lang=js"
export * from "./Forwarder.vue?vue&type=script&lang=js"
import style0 from "./Forwarder.vue?vue&type=style&index=0&id=05df558f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05df558f",
  null
  
)

export default component.exports